var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { omit } from "lodash-es";
import { createContext, useContext, } from "react";
function encodeQuery(query) {
    if (!query)
        return "";
    if (typeof query === "string")
        return "?".concat(query);
    var params = new URLSearchParams();
    Object.entries(query).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (Array.isArray(value)) {
            value.forEach(function (v) { return params.append(key, String(v)); });
        }
        else if (value !== null && value !== undefined) {
            params.append(key, String(value));
        }
    });
    var searchString = params.toString();
    return searchString ? "?".concat(searchString) : "";
}
// Default link component that just renders an anchor tag
function DefaultLink(_a) {
    var href = _a.href, children = _a.children, props = __rest(_a, ["href", "children"]);
    return (<a href={typeof href === "string"
            ? href
            : "".concat(href.pathname).concat(encodeQuery(href.query)).concat(href.hash || "")} {...omit(props, "passHref")}>
      {children}
    </a>);
}
// Create context with the default link component
export var UIContext = createContext(DefaultLink);
function UIProvider(_a) {
    var children = _a.children, Link = _a.Link;
    return (<UIContext.Provider value={Link !== null && Link !== void 0 ? Link : DefaultLink}>
      {children}
    </UIContext.Provider>);
}
export { UIProvider };
// Custom hook for using the UI context
export function useUIContext() {
    return useContext(UIContext);
}
